import {CustomClient4} from '../client';
import {UserTypes, TeamTypes} from 'mattermost-redux/action_types';
import {General} from 'mattermost-redux/constants';
import {batchActions} from 'redux-batched-actions';
import {logError} from 'mattermost-redux/actions/errors';
import {forceLogoutIfNecessary, bindClientFunc} from 'mattermost-redux/actions/helpers';
import {removeUserFromList} from 'mattermost-redux/utils/user_utils';

export function getUserDefinedStatuses(userId) {
    return async (dispatch, getState) => {
        let udfStatuses;
        try {
            udfStatuses = await CustomClient4.getUserDefinedStatuses(userId);
        } catch (error) {
            return {error};
        }
        return udfStatuses;
    };
}

export function saveOrUpdateUserDefinedStatus(userId, udfStatus) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.saveOrUpdateUserDefinedStatus(userId, udfStatus);
        } catch (error) {
            return {error};
        }
        return result;
    };
}

export function deleteUserDefinedStatus(userId, udfStatusId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.deleteUserDefinedStatus(userId, udfStatusId);
        } catch (error) {
            return {error};
        }
        return result;
    };
}

export function setCustomStatus(userId, udfStatusId) {

    return async (dispatch, getState) => {

        let status;
        dispatch({type: UserTypes.SET_STATUS_REQUEST}, getState);

        try {
            status = await CustomClient4.updateCustomStatus(userId, udfStatusId);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: UserTypes.SET_STATUS_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_STATUS,
                data: status
            },
            {
                type: UserTypes.SET_STATUS_SUCCESS
            }
        ]), getState);

        return status;
    };
}

export function blockUser(sender) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.blockUser(sender);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function checkBlockUser(sender) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.checkBlockUser(sender);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function unBlockUser(sender) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.unBlockUser(sender);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function getBlockList() {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.getBlockList();
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function setWatermarkImage(userId, imageData) {
    return async (dispatch, getState) => {
        dispatch({type: UserTypes.UPDATE_USER_REQUEST}, getState);

        try {
            await CustomClient4.uploadWatermarkImage(userId, imageData);
        } catch (error) {
            dispatch({type: UserTypes.UPDATE_USER_FAILURE, error}, getState);
            return null;
        }

        const actions = [
            {type: UserTypes.UPDATE_USER_SUCCESS}
        ];

        const profile = getState().entities.users.profiles[userId];
        if (profile) {
            actions.push({type: UserTypes.RECEIVED_PROFILE, data: {...profile, last_watermark_update: new Date().getTime() }});
        }

        dispatch(batchActions(actions), getState);

        return true;
    };
}

export function setBackgroundImage(userId, imageData) {
    return async (dispatch, getState) => {
        dispatch({type: UserTypes.UPDATE_USER_REQUEST}, getState);

        try {
            await CustomClient4.uploadBackgroundImage(userId, imageData);
        } catch (error) {
            dispatch({type: UserTypes.UPDATE_USER_FAILURE, error}, getState);
            return null;
        }

        const actions = [
            {type: UserTypes.UPDATE_USER_SUCCESS}
        ];

        const profile = getState().entities.users.profiles[userId];
        if (profile) {
            actions.push({type: UserTypes.RECEIVED_PROFILE, data: {...profile, last_background_update: new Date().getTime() }});
        }

        dispatch(batchActions(actions), getState);

        return true;
    };
}

export function getProfilesCanJoinTeam(teamId, page, perPage = General.PROFILE_CHUNK_SIZE) {
    return async (dispatch, getState) => {
        dispatch({type: UserTypes.PROFILES_NOT_IN_TEAM_REQUEST}, getState);

        let profiles;
        try {
            profiles = await CustomClient4.getProfilesCanJoinTeam(teamId, page, perPage);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: UserTypes.PROFILES_NOT_IN_TEAM_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_TEAM,
                data: profiles,
                id: teamId
            },
            {
                type: UserTypes.RECEIVED_PROFILES_LIST,
                data: profiles
            },
            {
                type: UserTypes.PROFILES_NOT_IN_TEAM_SUCCESS
            }
        ]), getState);

        return profiles;
    };
}

export function getProfilesCanJoinChannel(teamId, channelId, page, perPage = General.PROFILE_CHUNK_SIZE) {
    return async (dispatch, getState) => {
        dispatch({type: UserTypes.PROFILES_NOT_IN_CHANNEL_REQUEST}, getState);

        const {currentUserId} = getState().entities.users;

        let profiles;
        try {
            profiles = await CustomClient4.getProfilesCanJoinChannel(teamId, channelId, page, perPage);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: UserTypes.PROFILES_NOT_IN_CHANNEL_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        dispatch(batchActions([
            {
                type: UserTypes.RECEIVED_PROFILES_LIST_NOT_IN_CHANNEL,
                data: profiles,
                id: channelId
            },
            {
                type: UserTypes.RECEIVED_PROFILES_LIST,
                data: removeUserFromList(currentUserId, [...profiles])
            },
            {
                type: UserTypes.PROFILES_NOT_IN_CHANNEL_SUCCESS
            }
        ]), getState);

        return profiles;
    };
}

export function sendVerificationSMS(email) {
    return bindClientFunc(
        CustomClient4.sendVerificationSMS,
        UserTypes.VERIFY_EMAIL_REQUEST,
        UserTypes.VERIFY_EMAIL_SUCCESS,
        UserTypes.VERIFY_EMAIL_FAILURE,
        email
    );
}

export function verifyUserMobile(token, loginId) {
    return bindClientFunc(
        CustomClient4.verifyUserMobile,
        UserTypes.VERIFY_EMAIL_REQUEST,
        UserTypes.VERIFY_EMAIL_SUCCESS,
        UserTypes.VERIFY_EMAIL_FAILURE,
        token,
        loginId
    );
}

export function resetUserPasswordBySMS(token, loginId, newPassword) {

    return bindClientFunc(
        CustomClient4.resetUserPasswordBySMS,
        UserTypes.PASSWORD_RESET_REQUEST,
        UserTypes.PASSWORD_RESET_SUCCESS,
        UserTypes.PASSWORD_RESET_FAILURE,
        token,
        loginId,
        newPassword
    );
}

export function incrementMapUsage(userId) {
    return async (dispatch, getState) => {
        let result;
        try {
            result = await CustomClient4.incrementMapUsage(userId);
        } catch (error) {
            return error;
        }
        return result;
    };
}

export function sendPasswordResetSMS(loginId) {
    return bindClientFunc(
        CustomClient4.sendPasswordResetSMS,
        UserTypes.PASSWORD_RESET_REQUEST,
        UserTypes.PASSWORD_RESET_SUCCESS,
        UserTypes.PASSWORD_RESET_FAILURE,
        loginId
    );
}

export function sendOnRequestVerificationEmail(email) {

    const type = 'on_request';
    return bindClientFunc(
        CustomClient4.sendOnRequestVerificationEmail,
        UserTypes.VERIFY_EMAIL_REQUEST,
        UserTypes.VERIFY_EMAIL_SUCCESS,
        UserTypes.VERIFY_EMAIL_FAILURE,
        email,
        type
    );
}

export function getCountryCodeByIP() {
    return async (dispatch, getState) => {
        let result = {};
        try {
            result = await CustomClient4.getCountryCode();
        } catch (error) {
            return {error};
        }
        return result;
    }
}


export function findUserByCallee(callee) {
    return bindClientFunc(
        CustomClient4.getUserByCallee,
        UserTypes.USER_REQUEST,
        [UserTypes.RECEIVED_PROFILE, UserTypes.USER_SUCCESS],
        UserTypes.USER_FAILURE,
        callee
    );
}

export function lookupPossibleUsers(user) {
    return async (dispatch, getState) => {
        try {
            return await CustomClient4.lookupPossibleUsers(user);
        } catch (error) {
            return {error};
        }

    };
}

export function sendMeetingInviteToExternal(category, invites) {
    return async (dispatch, getState) => {
        let roomId;
        try {
            roomId =  await CustomClient4.sendMeetingInviteToExternal(category, invites);
        } catch (error) {
            return {error};
        }
        return roomId;
    };
}

export function getUserCleanUpTime(loginId) {
    return async (dispatch, getState) => {
        try {
            return await CustomClient4.getUserCleanUpTime(loginId);
        } catch (error) {
            return {error};
        }

    };
}


// +++ Cordchat - recovered from the 2024 production bundle (patched mattermost-redux actions/users).
// Loads the member profiles of several channels in one request.
export function getProfilesInChannels(channelIds, page = 0, perPage = General.PROFILE_CHUNK_SIZE) {
    return async (dispatch, getState) => {
        dispatch({type: UserTypes.PROFILES_IN_CHANNEL_REQUEST}, getState);

        const {currentUserId} = getState().entities.users;
        let profilesByChannel;
        try {
            profilesByChannel = await CustomClient4.getProfilesInChannels(channelIds, page, perPage);
        } catch (error) {
            forceLogoutIfNecessary(error, dispatch);
            dispatch(batchActions([
                {type: UserTypes.PROFILES_IN_CHANNEL_FAILURE, error},
                logError(error)(dispatch)
            ]), getState);
            return null;
        }

        const received = [];
        const result = [];
        const allProfiles = {};
        for (let i = 0; i < channelIds.length; i++) {
            const channelId = channelIds[i];
            const profiles = profilesByChannel[channelId];
            if (profiles && profiles.length > 0) {
                received.push({type: UserTypes.RECEIVED_PROFILES_LIST_IN_CHANNEL, data: profiles, id: channelId});
                result.push(removeUserFromList(currentUserId, [...profiles]));
                profiles.forEach((p) => {
                    allProfiles[p.id] = p;
                });
            }
        }

        dispatch(batchActions([
            ...received,
            {type: UserTypes.RECEIVED_PROFILES_LIST, data: removeUserFromList(currentUserId, [...Object.values(allProfiles)])},
            {type: UserTypes.PROFILES_IN_CHANNEL_SUCCESS}
        ]), getState);

        return result;
    };
}

// ---

export default {
    blockUser,
    unBlockUser,
    getProfilesInChannels
};


// WEBPACK FOOTER //
// ./custom-redux/actions/users.jsx